import { connect } from "react-redux";
import Lightbox from "./Lightbox";
import {
  addChoice,
  AddChoicePayload,
  removeChoice,
  RemoveChoicePayload,
} from "../state/actions/choiceActions";
import { useState } from "react";
import PartPrice from "./PartPrice";
import PartQuantity from "./PartQuantity";
import {
  ActionPayload,
  ID,
  Layout,
  Part as PartType,
  SectionType,
} from "../types";
import { RootState } from "../state/reducers";
import PartBoxImage from "./PartBoxImage";
import PartLabel from "./PartLabel";
import getPackagePart from "../helpers/getPackagePart";

interface PartProps {
  part?: PartType;
  sectionType: SectionType;
  isSelected: boolean;
  isDisabled: boolean;
  isHidden: boolean;
  addChoice: (data: PartType) => ActionPayload<AddChoicePayload>;
  removeChoice: (id: ID) => ActionPayload<RemoveChoicePayload>;
  getPackage: (id: ID) => PartType | undefined;
  layout: Layout;
}

const Part: React.FC<PartProps> = ({
  part,
  sectionType,
  isSelected,
  isDisabled,
  isHidden,
  addChoice,
  removeChoice,
  getPackage,
  layout,
}) => {
  if (!part || isHidden) return null;

  const [isLightbox, setIsLightbox] = useState(false);

  const toggle = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (!isSelected) {
      addChoice(part);
    } else {
      if (sectionType === "multiple") {
        removeChoice(part.id);
      }
    }
  };

  const imagePopup = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLightbox(!isLightbox);
  };

  const activeClass = isSelected ? "active" : "";
  const disabledClass = isDisabled ? "disabled" : "";
  const isBoxLayout = layout === "box";

  return (
    <div
      className={`part-container ${disabledClass} ${activeClass}`}
      onClick={isBoxLayout && !isDisabled ? toggle : undefined}
    >
      <PartBoxImage
        isBoxLayout={isBoxLayout}
        color={part.color}
        imageSrc={part.image}
      />
      <a
        className={`part-checkbox ${activeClass}`}
        onClick={!isDisabled ? toggle : undefined}
      ></a>
      <PartLabel
        isBoxLayout={isBoxLayout}
        label={part.label}
        selectOnClick={isDisabled ? undefined : toggle}
        imageOnClick={imagePopup}
        color={part.color}
        imageSrc={part.image}
      />
      <PartQuantity
        max={part.maxQuantity}
        partId={part.id}
        layout={layout}
        isSelected={isSelected}
      />
      <PartPrice
        price={part.price}
        discount={part.discount}
        thePackage={getPackage(part.id)}
      />
      <Lightbox url={part.image} isOpen={isLightbox} onClose={imagePopup} />
    </div>
  );
};

interface ConnectProps {
  partId: ID;
  sectionType: SectionType;
  layout: Layout;
}

export default connect(
  (state: RootState, props: ConnectProps) => {
    const { partId, sectionType, layout } = props;

    const getPackage = getPackagePart(
      state.formData.entities.parts,
      state.packaged
    );
    return {
      layout,
      sectionType,
      getPackage,
      part: state.formData.entities.parts.byId[partId],
      isSelected: state.choices.byId[partId] ? true : false,
      isDisabled: state.disabled.includes(partId),
      isHidden: state.hidden.includes(partId),
    };
  },
  { addChoice, removeChoice }
)(Part);
